/**
 * Bootstrap Table Czech translation
 * Author: Lukas Kral (monarcha@seznam.cz)
 * Author: Jakub Svestka <svestka1999@gmail.com>
 */

$.fn.bootstrapTable.locales['cs-CZ'] = $.fn.bootstrapTable.locales['cs'] = {
  formatCopyRows () {
    return 'Copy Rows'
  },
  formatPrint () {
    return 'Print'
  },
  formatLoadingMessage () {
    return 'Načítám, čekejte prosím'
  },
  formatRecordsPerPage (pageNumber) {
    return `${pageNumber} položek na stránku`
  },
  formatShowingRows (pageFrom, pageTo, totalRows, totalNotFiltered) {
    if (totalNotFiltered !== undefined && totalNotFiltered > 0 && totalNotFiltered > totalRows) {
      return `Zobrazena ${pageFrom}. - ${pageTo}. položka z celkových ${totalRows} (filtered from ${totalNotFiltered} total rows)`
    }

    return `Zobrazena ${pageFrom}. - ${pageTo}. položka z celkových ${totalRows}`
  },
  formatSRPaginationPreText () {
    return 'previous page'
  },
  formatSRPaginationPageText (page) {
    return `to page ${page}`
  },
  formatSRPaginationNextText () {
    return 'next page'
  },
  formatDetailPagination (totalRows) {
    return `Showing ${totalRows} rows`
  },
  formatClearSearch () {
    return 'Clear Search'
  },
  formatSearch () {
    return 'Vyhledávání'
  },
  formatNoMatches () {
    return 'Nenalezena žádná vyhovující položka'
  },
  formatPaginationSwitch () {
    return 'Skrýt/Zobrazit stránkování'
  },
  formatPaginationSwitchDown () {
    return 'Show pagination'
  },
  formatPaginationSwitchUp () {
    return 'Hide pagination'
  },
  formatRefresh () {
    return 'Aktualizovat'
  },
  formatToggle () {
    return 'Přepni'
  },
  formatToggleOn () {
    return 'Show card view'
  },
  formatToggleOff () {
    return 'Hide card view'
  },
  formatColumns () {
    return 'Sloupce'
  },
  formatColumnsToggleAll () {
    return 'Toggle all'
  },
  formatFullscreen () {
    return 'Fullscreen'
  },
  formatAllRows () {
    return 'Vše'
  },
  formatAutoRefresh () {
    return 'Auto Refresh'
  },
  formatExport () {
    return 'Export data'
  },
  formatJumpTo () {
    return 'Jdi'
  },
  formatAdvancedSearch () {
    return 'Advanced search'
  },
  formatAdvancedCloseButton () {
    return 'Close'
  },
  formatFilterControlSwitch () {
    return 'Hide/Show controls'
  },
  formatFilterControlSwitchHide () {
    return 'Hide controls'
  },
  formatFilterControlSwitchShow () {
    return 'Show controls'
  },
  formatSortBy: function formatSortBy() {
    return 'Dle';
  },
  formatSort: function formatSort() {
    return 'Řadit';
  },
  formatCancel: function formatCancel() {
    return 'Storno';
  },
  formatMultipleSort: function formatMultipleSort() {
    return 'Víceúrovňové řazení';
  },
  formatAddLevel: function formatAddLevel() {
    return 'Přidat úroveň';
  },
  formatDeleteLevel: function formatDeleteLevel() {
    return 'Odstranit úroveň';
  },
  formatColumn: function formatColumn() {
    return 'Sloupec';
  },
  formatOrder: function formatOrder() {
    return 'Směr';
  },
  formatSortOrders: function formatSortOrders() {
    return {
      asc: 'Vzestupně',
      desc: 'Sestupně'
    };
  },
  formatThenBy: function formatThenBy() {
    return 'Poté';
  },
  formatDuplicateAlertDescription: function formatDuplicateAlertDescription() {
    return 'Prosím odstraňte nebo změnte stejné sloupce.';
  },
  formatDuplicateAlertTitle: function formatDuplicateAlertTitle() {
    return 'Nalezeny duplicity!';
  }

}

$.extend($.fn.bootstrapTable.defaults, $.fn.bootstrapTable.locales['cs-CZ'])
